import UsersTableEmptyMessage from "./UsersTableEmptyMessage";

export default UsersTableEmptyMessage;